module.exports = __webpack_public_path__ + "img/E-WEB-Goal-5.9da33cf4.png";